import { MessageSquarePlus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import FeedbackModal from "./FeedbackModal";

const FeedbackButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-6 right-6 z-40 h-14 w-14 rounded-full shadow-lg hover:scale-110 transition-transform"
        size="icon"
        aria-label="Envoyer un feedback"
      >
        <MessageSquarePlus className="h-6 w-6" />
      </Button>
      
      <FeedbackModal open={isOpen} onOpenChange={setIsOpen} />
    </>
  );
};

export default FeedbackButton;
